var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showCustomDialog, showProgressDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useAttachmentClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useDocumentLibraryStorage, useDocumentLibraryTranslations } from '../../../hooks';
import { maxFileSize } from '../contants';
import { FileDropBox, FileUploadRow } from './components';
export function showUploadMultipleFiles({ ownerId, parentId, onDone }) {
    showCustomDialog({
        content: (close) => React.createElement(MultipleFileUpload, { ownerId: ownerId, parentId: parentId, close: close, onDone: onDone }),
        maxWidth: 'lg',
    });
}
export const MultipleFileUpload = ({ close, ownerId, parentId, onDone, }) => {
    const { t } = useDocumentLibraryTranslations();
    const attachmentClient = useAttachmentClient();
    const fileClientStorage = useDocumentLibraryStorage();
    const [extendedFiles, setExtendedFiles] = React.useState([]);
    const isValidFileSize = extendedFiles.every((file) => file.file.size < maxFileSize);
    const filesHaveError = extendedFiles.some((extendedFile) => Object.values(extendedFile.errors).some(Boolean));
    const uploadIsValid = isValidFileSize && !filesHaveError;
    const handleUploadFiles = ({ parentId, ownerId, close, onDone }) => {
        showProgressDialog({
            title: t('multipleFilesUpload.uploadFilesProgress'),
            callback: (done) => __awaiter(void 0, void 0, void 0, function* () {
                const fileDuplicationResponses = [];
                let validationFiles = extendedFiles;
                const isUploadValid = () => {
                    return validationFiles.every((file) => Object.values(file.errors).every((error) => !error));
                };
                for (let i = 0; i < validationFiles.length; i++) {
                    const file = validationFiles[i];
                    if (file.editedName) {
                        try {
                            const response = yield fileClientStorage.isFileExists({
                                name: file.editedName,
                                parentId: parentId,
                            });
                            fileDuplicationResponses.push(Object.assign(Object.assign({}, response), { name: file.file.name }));
                        }
                        catch (error) {
                            handleErrorSnackbar(error);
                        }
                    }
                }
                if (fileDuplicationResponses.some((response) => response.exists)) {
                    validationFiles = validationFiles.map((file) => (Object.assign(Object.assign({}, file), { errors: Object.assign(Object.assign({}, file.errors), { duplicateNameError: file.errors.duplicateNameError ||
                                fileDuplicationResponses.some((response) => response.name === file.file.name && response.exists) }) })));
                    setExtendedFiles(validationFiles);
                }
                if (isUploadValid()) {
                    let filesSuccessfullyUploaded = true;
                    for (let i = 0; i < validationFiles.length; i++) {
                        const file = validationFiles[i];
                        try {
                            yield fileClientStorage.createFile({
                                name: file.editedName,
                                ownerId: ownerId,
                                parentId: parentId,
                                contentType: file.file.type,
                                contentLength: file.file.size,
                                content: file.file,
                                additionalData: { summary: file.summary },
                            });
                        }
                        catch (error) {
                            handleErrorSnackbar(error);
                            filesSuccessfullyUploaded = false;
                        }
                    }
                    if (filesSuccessfullyUploaded) {
                        showAlertSnackbar({
                            message: t('multipleFilesUpload.fileUploaded', { count: extendedFiles.length }),
                            type: 'success',
                            verticalPosition: 'bottom',
                            horizontalPosition: 'center',
                            autoHideDuration: 2000,
                        });
                    }
                    close();
                }
                onDone === null || onDone === void 0 ? void 0 : onDone();
                done();
            }),
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { variant: 'h6' }, t('multipleFilesUpload.title')),
        React.createElement(DialogContent, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(FileDropBox, { extendedFiles: extendedFiles, onSetFiles: setExtendedFiles }),
            extendedFiles.length > 0 && (React.createElement(React.Fragment, null, extendedFiles.map((file) => (React.createElement(FileUploadRow, { key: file.file.name, extendedFiles: extendedFiles, file: file, onSetFiles: setExtendedFiles })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => close() }, t('multipleFilesUpload.cancelButton')),
            React.createElement(Button, { color: 'primary', disabled: !uploadIsValid, onClick: () => {
                    handleUploadFiles({
                        t,
                        attachmentClient,
                        fileClientStorage,
                        extendedFiles,
                        parentId,
                        ownerId,
                        close,
                        onSetFiles: setExtendedFiles,
                        onDone: onDone,
                    });
                } }, t('multipleFilesUpload.uploadButton')))));
};
